import React, { createContext, useContext, useState } from 'react';

const SongSearchContext = createContext();

export const useSongSearch = () => {
  const context = useContext(SongSearchContext);
  if (!context) {
    throw new Error('useSongSearch must be used within a SongSearchProvider');
  }
  return context;
};

export const SongSearchProvider = ({ children, onSearchPerformed }) => {
  const [searchTerm, setSearchTerm] = useState('');

  // The search box shows what was typed (ENG-508): storing the trimmed
  // value swallowed a trailing space as it was typed, so "hey jude" typed
  // key by key became "heyjude". Matching trims instead.
  const performSearch = (term) => {
    const trimmedTerm = term.trim();
    setSearchTerm(term);
    
    // Notify parent when a search is performed with actual content
    if (trimmedTerm && onSearchPerformed) {
      onSearchPerformed();
    }
  };

  const clearSearch = () => {
    setSearchTerm('');
  };

  const value = {
    searchTerm,
    performSearch,
    clearSearch
  };

  return (
    <SongSearchContext.Provider value={value}>
      {children}
    </SongSearchContext.Provider>
  );
};

export default SongSearchContext;